/**
 * A JSON string that decodes to `T`. The phantom key only exists at the type
 * level, so a `JsonEncoded<T>` is still a plain `string` at runtime.
 */
export type JsonEncoded<T> = string & { readonly __decoded?: T };

export const encodeJson = <T>(value: T) =>
  JSON.stringify(value) as JsonEncoded<T>;

export const decodeJson = <T>(encoded: JsonEncoded<T>): T =>
  JSON.parse(encoded);
